import { render } from "./TwoFactorAuthVerify.vue?vue&type=template&id=b505f14c"
import script from "./TwoFactorAuthVerify.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthVerify.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__